/** Account Management — admin-only. Isolated from buyer/seller checklists and client messaging. */
import { adminPlanOptions, planByCatalogId } from "@billing/catalog.js";

export const ACCOUNTS_PREFIX = "dh_accounts_";
export const ACCOUNTS_EVENT = "dh-accounts-change";

export const ACCOUNT_ROLES = [
  { id: "agent", label: "Agent" },
  { id: "broker", label: "Broker" },
  { id: "admin", label: "Admin" },
  { id: "corporate", label: "Enterprise" },
];

export const ACCOUNT_STATUSES = [
  { id: "active", label: "Active" },
  { id: "beta", label: "Beta" },
  { id: "suspended", label: "Suspended" },
  { id: "cancelled", label: "Cancelled" },
  { id: "deleted", label: "Deleted" },
];

export const SUB_STATUSES = [
  { id: "signup", label: "Sign-up" },
  { id: "active", label: "Active" },
  { id: "past_due", label: "Past due" },
  { id: "grace", label: "Grace" },
  { id: "suspended", label: "Suspended" },
  { id: "cancelled", label: "Cancelled" },
];

export const ORG_TYPES = [
  { id: "brokerage", label: "Brokerage" },
  { id: "corporate", label: "Corporate" },
];

/** Admin billing catalog — mirrors checkout (Agent Standard · Broker Office · Enterprise). */
export const PLANS = adminPlanOptions();

export const PAYMENT_RESULTS = ["succeeded", "failed", "refunded"];
export const GRACE_DAYS = 7;
export const PAST_DUE_TO_GRACE_DAYS = 3;

export function canManageAccounts(session) {
  return session?.role === "admin";
}

export function planById(id) {
  const catalog = planByCatalogId(id);
  if (catalog) {
    return {
      id: catalog.id,
      label: catalog.name,
      amount: catalog.monthly,
      interval: "month",
      role: catalog.role,
      seats: catalog.maxAgents || 0,
      productId: catalog.productId,
    };
  }
  return PLANS.find((row) => row.id === id) || PLANS[0];
}

export function planLabel(id) {
  const plan = planById(id);
  if (!plan) return id || "";
  return plan.amount
    ? `${plan.label} · $${Number(plan.amount).toFixed(2)}/${plan.interval === "month" ? "mo" : plan.interval}`
    : plan.label;
}

export function statusLabel(list, id) {
  return list.find((row) => row.id === id)?.label || id || "";
}

export function roleLabel(id) {
  return statusLabel(ACCOUNT_ROLES, id);
}

export function money(value) {
  const n = Number(value || 0);
  return n.toLocaleString(undefined, { style: "currency", currency: "USD" });
}
